import {DirectiveOptions} from 'vue';

export const focusDirective: DirectiveOptions = {
  inserted: function (el) {
    el.focus();
  }
}


// WEBPACK FOOTER //
// node_modules/wc-lib/src/wc-ui/directives/focus.ts